import { Grid, Paper, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { TabsLayout } from "../../../shared/components";
import { LinkKeepUTM } from "../../../shared/components/LinkKeepUTM";
import { RedirectKeepUTM } from "../../../shared/components/RedirectKeepUTM";
import { Header } from "../../../shared/components/header";
import type { RootState } from "../../../store";
import {
  AssignedContentList,
  WatchedAssignedContentList,
} from "../../components";
import { useStyles } from "./styles";

export const ListAssignedContent = ({ navigation }) => {
  const classes = useStyles();
  const organizationSettings = useSelector(
    (state: RootState) => state.auth.login.organization.settings
  );

  if (organizationSettings.isContentFunctionalityEnabled === false) {
    return <RedirectKeepUTM from="/assignedContent" to="/participant" />;
  }

  return (
    <>
      <Header navigation={navigation}>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="stretch"
        >
          <Paper elevation={1} className={classes.container}>
            <Grid item xs={12} />
            <TabsLayout
              title="My Content"
              additionalActionsComponent={
                <Typography align="right">
                  <LinkKeepUTM
                    className={classes.link}
                    to="/participant/content"
                  >
                    View all available content
                  </LinkKeepUTM>
                </Typography>
              }
              listComponents={[
                {
                  slug: "/participant/assignedContent",
                  label: "Content to Watch",
                  component: <AssignedContentList />,
                },
                {
                  slug: "/participant/assignedContent/WatchedContent",
                  label: "Watched Content",
                  component: <WatchedAssignedContentList />,
                },
              ]}
            />
          </Paper>
        </Grid>
      </Header>
    </>
  );
};

ListAssignedContent.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

ListAssignedContent.defaultProps = {
  navigation: [],
};
